import api from 'services/api';

export type ApplessSensorProps = {
  uuid?: string;
  sensorId: string;
  buildingUuid: string;
  spaceUuid?: string;
  reversed: boolean;
  location?: string;
  type?: string;
};

/**
 * This function creates a new appless occupancy sensor record.
 */
const createApplessOccupancySensor = async (newApplessSensor: ApplessSensorProps) => {
  const response = await api.post<ApplessSensorProps>(
    '/apiv1/appless_occupancy_sensors/',
    newApplessSensor
  );
  return response?.data;
};

/**
 * Retrieve all the appless occupancy sensor records.
 */
const findAllApplessOccupancySensors = async () => {
  const response = await api.get<ApplessSensorProps[]>('/apiv1/appless_occupancy_sensors/');
  return response?.data;
};

/**
 * Retrieve the appless occupancy sensor record by its ID.
 */
const findApplessOccupancySensorByID = async (uuid: string | undefined) => {
  const response = await api.get<ApplessSensorProps>(`/apiv1/appless_occupancy_sensor/${uuid}/`);
  return response?.data;
};

/**
 * This function updates the appless occupancy sensor by its ID.
 */
const updateApplessOccupancySensorByID = async (
  uuid: string | undefined,
  updatedApplessSensor: ApplessSensorProps
) => {
  const response = await api.put<ApplessSensorProps>(
    `/apiv1/appless_occupancy_sensor/${uuid}/`,
    updatedApplessSensor
  );
  return response?.data;
};

/**
 * This function deletes an appless occupancy sensor by its ID.
 */
const deleteApplessOccupancySensorByID = async (uuid: string | undefined) => {
  const response = await api.delete<ApplessSensorProps>(`/apiv1/appless_occupancy_sensor/${uuid}/`);
  return response?.data;
};

const ApplessSensorService = {
  createApplessOccupancySensor,
  findAllApplessOccupancySensors,
  findApplessOccupancySensorByID,
  updateApplessOccupancySensorByID,
  deleteApplessOccupancySensorByID
};

export default ApplessSensorService;
